import { createFileRoute } from '@tanstack/react-router';

import { ensureVirtualTourByIdQueryData } from '@/features/estate-media/api/virtual-tour';
import { VirtualTourBreadcrumb } from '@/features/estates/components/virtualTourBreadcrumb';

const RouteComponent = () => {
  return <div>Virtual Tour View (placeholder)</div>;
};

export const Route = createFileRoute(
  '/_authenticated/_nosidebar-layout/estates/$estateId/media/virtual-tour/$tourId/view'
)({
  loader: ensureVirtualTourByIdQueryData,
  component: RouteComponent,
  staticData: {
    breadcrumb: () => <VirtualTourBreadcrumb />,
  },
});
